import { apiRequest } from "../util/apiUtils";

export const followList = async (params) => {
  try {
    const res = await apiRequest("get", `connection/follow-list`, {
      queries: params,
    });
    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationFollow = async (payload) => {
  try {
    const res = await apiRequest("post", `connection/follow`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationUnfollow = async (payload) => {
  try {
    const res = await apiRequest("post", `connection/unfollow`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
